import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResearcherTaskList, WorkOrder, WorkOrderComplete, SubmitTask, SubmitTaskDialog } from '../../models/index';
import Jurisdiction from '../../models/jurisdiction';
import { ResearcherService, MessageQueService } from '../../services/index';
import BrowserWindowObjectService from '../../services/browserWindowObjectService';
import { ConfirmResult, AlertResult } from '../../models/alertifyPromise';
import PopupHelper from '../../models/popupHelper';
import ComplianceAuditLog from '../../models/complianceAuditLog';
import ComplianceAuditLogService from '../../services/complianceAuditLogService';

export enum woc {
  removePending = 'RP',
  noHits = 'NH',
  removeNoHits = 'RH',
  pendingRequest = 'PR',
}

@Component({
  templateUrl: 'ResearcherTaskList.component.html',
  styleUrls: ['researcherTaskList.component.scss'],
  providers: [ResearcherService, BrowserWindowObjectService, MessageQueService]
})
export class ResearcherTaskListComponent implements OnInit {
  totalWorkOrdersOnPage = 0;
  totalWorkOrders = 0;
  config: string[];
  submitTaskDialog: SubmitTaskDialog[] = [];
  submitTask: SubmitTask[] = [];
  filter: SubmitTask[] = [];
  submitList: SubmitTask;
  defaultStr = 'Not Selected';
  taskList: ResearcherTaskList;
  wo: WorkOrder[] = [];
  stateData: WorkOrder[] = [];
  woData: WorkOrder;
  isConfirmed: Boolean;
  juris: Jurisdiction;
  jurFilters: Jurisdiction[] = [];
  originalAdmitted: any[] = [];
  admittedAll: any[] = [];
  requestNbrs: any[] = [];
  model: any = {};
  noHits: HTMLInputElement;
  pending: HTMLInputElement;
  anf: HTMLInputElement;
  originalStatus: string;
  woComplete: WorkOrderComplete;
  complianceAuditLogs: Array<ComplianceAuditLog>;
  sortParams: string;
  headerRP = 0;
  headerNH = 0;
  headerRH = 0;
  headerPR = 0;
  wComment: Window;
  cacheControlKey: string;

  constructor(private router: Router, private researcherService: ResearcherService, private route: ActivatedRoute,
    private bwObjectService: BrowserWindowObjectService, private msgSvc: MessageQueService,
    private complianceAuditLogService: ComplianceAuditLogService) {

    this.model.jurisdictionId = 0;
    this.woComplete = new WorkOrderComplete;
    this.submitList = new SubmitTask;
    this.model.viewAsLink = false;
    this.route.params.subscribe(params => {
      this.model.requestType = params['status'];
      this.model.type = localStorage.getItem('sortType');
      this.model.jurisdictionId = (params['jurisdictionId'] === undefined) ? 0 : params['jurisdictionId'];
      this.model.selectedValue = 0;
    });
  }
  ngOnInit() {
    this.msgSvc.setControlKey(); // ('CacheControlKey');

    if (this.model.type === 'sorting') {
      this.model.selectedValue = JSON.parse(localStorage.getItem('selection'));
      this.totalWorkOrdersOnPage = this.wo.length;
      this.totalWorkOrders = this.wo.length;

      if (this.model.selectedValue !== 'ns') {
        this.filterWorkOrderList();
      } else {
        this.getResearcherTaskData();
      }
      this.removeSortingArray();
    } else {
      this.setDefaultOrder();
      this.getResearcherTaskData();
    }
    this.model.isSubmitDisabled = false;
  }
  getJurisdiction() {
    for (const item of JSON.parse(localStorage.getItem('jurisdictions'))) {
      this.juris = {
        jurisdictionId: item.jurisdictionId,
        description: item.description,
        count: 0
      };
      this.jurFilters.push(this.juris);
    }
  }
  getResearcherTaskData() {
    let i = 0;
    this.taskList = new ResearcherTaskList;
    this.woData = new WorkOrder;
    this.wo.length = 0;
    this.jurFilters.length = 0;
    this.stateData.length = 0;
    this.researcherService.getResearchTaskList(this.model.requestType, this.model.jurisdictionId)
      .subscribe(
        (data) => {
          this.totalWorkOrdersOnPage = data.length;
          this.totalWorkOrders = data.length;
          for (const item of data) {
            for (0; i < 1; i++) { // item.sourceType
              this.taskList = {
                calculatedValue: (item.sourceType === 'EX') ? this.getExTotal(item) : this.getIntTotal(item),
                currentSysDt: item.iso_SysDt, crrsrCount: 17, dataType1: 'string', dataType2: 'number',
                dataType3: 'number', detailWork: this.model.requestType,
                displayNumber: (item.sourceType === 'EX') ? this.getExDisplayNumber(item) : this.getIntDisplayNumber(item),
                emailAddress: item.emailAddress, errorDescription: '', filterText: '', filterTotal: 1, fullName: item.sourceName,
                gisUserName: item.gisUserName, lateTotal: item.lateTotal, max: 100, min: 1,
                newTotal: item.newTotal, numbers: (item.newTotal > item.max) ? item.max : item.newTotal,
                requestTotal: item.requestTotal, sortOne: 'jurisdiction', sortTwo: 'dis_RequestDt',
                sortThree: 'refName', sortOrder1: 'ascending', sortOrder2: 'descending', sortOrder3: 'ascending',
                sourceName: item.sourceName, sourceType: item.sourceType, sysID: '', totalDisplayRequest: 1
              };
            }
            this.woData = {
              admissionInfo: '', // item.admissionInfo,
              admittedCrimeNotFound: item.admittedCrimeNotFound,
              caseNbr: item.caseNbr,
              checked: false,
              crrsrCount: 200,
              custId: item.custId,
              deferred: item.deferred,
              dis_DueDt: item.dis_DueDt,
              dis_RequestDt: item.dis_RequestDt,
              dis_RequestDt_sort: new Date(item.dis_RequestDt),
              dob: item.dob,
              dobDisplay: (item.dob !== '') ? item.dob : 'No DOB On File',
              driversLicense: '', // item.driversLicense,
              emailAddress: item.emailAddress,
              filterText: item.filterText,
              filterTotal: 100, // count(CR_RequestSpecialRetrieve[@JurisdictionId = $filterText])
              hrefAttachDoc: item.hrefAttachDoc,
              hrefCif: item.hrefCif,
              gisUserName: item.gisUserName,
              isLate: this.getLateStatus(this.model.requestType, item.dis_DueDt, item.iso_SysDt), // using dis_DueDt because of format
              iso_DueDt: item.iso_DueDt,
              iso_SysDt: item.iso_SysDt,
              jurisdiction: item.jurisdiction,
              jurisdictionId: item.jurisdictionId,
              lateTotal: item.lateTotal,
              linkColor: this.getLinkColor(item),
              manualInd: item.manualInd,
              max: 100,
              min: 1,
              nameRefNbr: item.nameRefNbr,
              newTotal: item.newTotal,
              ociIndicator: item.ociIndicator,
              pendingComments: item.pendingComments,
              phone: '',
              position: '',
              printInd: item.printInd,
              recordFound: item.recordFound,
              refAddr1: item.refAddr1,
              refCity: item.refCity,
              refName: item.refName,
              refState: item.refState,
              refZip: item.refZip,
              requestNbr: item.requestNbr,
              requestTotal: item.requestTotal,
              reportAll: item.reportAll,
              reportAllText: this.getReportAllText(item),
              searchFromDt: item.searchFromDt,
              searchToDt: item.searchToDt,
              signedRelInd: item.signedRelInd,
              sourceName: item.sourceName,
              sourceType: item.sourceType,
              specialInstr: item.specialInstr,
              showInstruction: (item.specialInstr === 'Y') ? 'Display' : 'Invisible',
              ssn: item.ssn,
              ssnDisplay: (item.ssn.length > 0) ? 'XXX-XX-' + item.ssn.substr(5) : 'No Social Security Nbr On File',
              status: item.status,
              strWork: '',
              totalInstruction: (item.specialInstr === 'Y') ? 1 : 0,
              url: '',
              woPhone: (this.validatePhone(item.sourceType, item.phone)) ? item.phone : '',
              woSourceName: (this.model.requestType === 'ByCaseAll') ? item.sourceName : '',
              woURL: (this.validateUrl(item.sourceType, item.url)) ? item.url : '',
              woValue: this.getCaseStatus(item),
              woNoHitsDisable: this.setDisabled(item, 'NoHits'),
              woPendingDisable: this.setDisabled(item, 'Pending'),
              woNoHitsDisplay: this.display(item, 'NoHits'),
              woManualDisplay: this.display(item, 'Manual'),
              woPendingDisplay: this.display(item, 'Pending'),
              woPendingLinkDisplay: this.display(item, 'PendingLink'),
              woRecordDisplay: this.display(item, 'RecordFound'),
              woCommentsDisplay: this.display(item, 'Comments'),
              woSearchDisplay: this.display(item, 'SearchCapture'),
              woDeferredDisplay: this.display(item, 'Deferred'),
              woAdmittedDisplay: '',
              woNoHitsChecked: this.setCheckbox(item, 'NoHits'),
              woManualChecked: this.setCheckbox(item, 'Manual'),
              woPendingChecked: this.setCheckbox(item, 'Pending'),
              woDeferredChecked: this.setCheckbox(item, 'Deferred'),
              woAdmittedChecked: this.setCheckbox(item, 'Admitted'),
              woNoHitsName: 'cbNoHits' + item.requestNbr,
              woManualName: 'cbManual' + item.requestNbr,
              woPendingName: 'cbPending' + item.requestNbr,
              woDeferredName: 'cbDeferred' + item.requestNbr,
              woAdmittedName: 'cbAdmitted' + item.requestNbr,
              licenseNumber: item.licenseNumber,
              isHeightenedIdentifier: item.isHeightenedIdentifier,
              colorValue: this.getColorValue(item.status, item.dis_DueDt, item.iso_SysDt),
            };
            this.wo.push(this.woData);
          }
          for (const item of JSON.parse(localStorage.getItem('jurisdictions'))) {
            this.juris = {
              jurisdictionId: item.jurisdictionId,
              description: item.description,
              count: 0
            };
            this.jurFilters.push(this.juris);
          }
        });
    this.stateData = this.wo;
    this.isJurisVisible();
  }
  isJurisVisible(): Boolean {
    if (this.taskList.sourceType === 'EX') {
      if (this.taskList.detailWork === 'New' || this.taskList.detailWork === 'Late' || this.taskList.detailWork === 'Filter') {
        return true;
      } else {
        return false;
      }
    } else if (this.taskList.sourceType === undefined) {
      return true;
    } else {
      return false;
    }
  }
  isVisible(type: string, validate: string): Boolean {
    if (type === 'IH') {
      return (validate !== '') ? true : false;
    } else {
      return false;
    }
  }
  getCaseStatus(item: WorkOrder): string {
    let status: string;
    if (item.sourceType === 'IH') {
      if (item.custId !== '') {
        status = `<a routerLinkActive='active' href="${item.hrefCif}custID= ${item.custId}" target="_blank">{{item.custId}}</a>`;
      }
    }
    if (item.printInd === 'Y') {
      status = 'Has Been Printed';
      this.model.viewAsLink = false;
    }
    if (item.signedRelInd === 'Y') {
      status = 'Release Required';
      this.model.viewAsLink = false;
    }
    if (item.status === 'W' || item.status === 'C' || item.status === 'U' || item.status === 'E' || item.signedRelInd === 'Y' || item.ociIndicator === 'Y') {
      status = item.custId;
      this.model.viewAsLink = false;
    }
    return status;
  }
  getReportAllText(item: WorkOrder): string {
    let status: string;
    if (item.reportAllText !== '' && item.reportAllText !== null && item.reportAllText !== undefined) {
      status = item.reportAllText;
    } else {
      status = '';
    }
    return status;
  }
  getExDisplayNumber(item: WorkOrder): number {
    if (this.model.requestType === 'New') {
      const number = (item.newTotal > item.max) ? item.max : item.newTotal;
      return (number > item.newTotal) ? item.newTotal : number;
    } else if (this.model.requestType === 'Late') {
      return (item.lateTotal > item.max) ? item.max : item.lateTotal;
    } else if (this.taskList.filterText !== '') {
      return (item.filterTotal > item.max) ? item.max : item.filterTotal;
    } else if (this.model.requestType === 'Filter') {
      return (item.filterTotal > item.max) ? item.filterTotal : item.max;
    } else {
      return (this.taskList.totalDisplayRequest > item.max) ? item.max : this.taskList.totalDisplayRequest;
    }
  }
  getExTotal(item: WorkOrder): number {
    if (this.model.requestType === 'New') {
      return item.newTotal;
    } else if (this.model.requestType === 'Late') {
      return item.lateTotal;
    } else if ((item.filterText !== '') || (this.model.requestType === 'Filter')) {
      return item.filterTotal;
    } else {
      return this.taskList.totalDisplayRequest;
    }
  }
  getIntDisplayNumber(item: WorkOrder): number {
    if (this.model.requestType === 'New') {
      return (this.taskList.totalDisplayRequest > item.newTotal) ? item.newTotal : this.taskList.totalDisplayRequest;
    } else if (this.model.requestType === 'Late') {
      return (this.taskList.totalDisplayRequest > item.lateTotal) ? item.lateTotal : this.taskList.totalDisplayRequest;
    } else {
      return (item.max > this.taskList.totalDisplayRequest) ? this.taskList.totalDisplayRequest : item.max;
    }
  }
  getIntTotal(item: WorkOrder): number {
    if (this.model.requestType === 'New') {
      return item.newTotal;
    } else if (this.model.requestType === 'Late') {
      return item.lateTotal;
    } else {
      return this.taskList.totalDisplayRequest;
    }
  }
  validateUrl(sourceType: string, url: string): boolean {
    if (sourceType === 'IH') {
      return (url !== '') ? true : false;
    } else {
      return false;
    }
  }
  getColorValue(status: string, disDueDt: string, isoSysDt: string): string {
    let color: string;
    if (status === 'C' || status === 'W' || status === 'U') {
      color = 'Green';
    } else if (status === 'I' || status === 'L' || status === 'Q') {
      color = (this.parseDate(disDueDt, isoSysDt)) ? 'Red' : 'Black';
    } else {
      color = (this.getLateStatus(this.model.requestType, disDueDt, isoSysDt)) ? 'Red' : 'Black';
    }
    return color;
  }
  getLateStatus(detailWork: string, disDueDt: string, isoSysDt: string): Boolean {
    if (detailWork === 'Late') {
      return true;
    } else {
      return (this.parseDate(disDueDt, isoSysDt)) ? true : false;
    }
  }
  parseDate(disDueDt: string, isoSysDt: string): Boolean {
    return (new Date(disDueDt) < new Date(isoSysDt)) ? true : false;
  }
  validatePhone(sourceType: string, phone: string): boolean {
    if (sourceType === 'IH') {
      return (phone !== '') ? true : false;
    } else {
      return false;
    }
  }
  display(item: WorkOrder, type: string): string {
    let display = '';
    switch (type) {
      case 'NoHits': {
        display = 'Display';
        break;
      }
      case 'Manual': {
        if (item.ociIndicator === 'Y') {
          display = 'Display';
        } else {
          display = 'Invisible';
        }
        break;
      }
      case 'Pending': {
        display = 'Display';
        break;
      }
      case 'PendingLink': {
        if (item.status === 'C' || item.status === 'W' || item.status === 'U') {
          display = 'Disable';
        } else {
          display = 'Display';
        }
        break;
      }
      case 'Deferred': {
        if (item.status === 'Q') {
          display = 'Display';
        } else {
          display = 'Invisible';
        }
        break;
      }
      case 'SearchCapture': {
        if (item.status !== 'C' && item.status !== 'W' && item.status !== 'U') {
          if (this.taskList.sourceType !== 'EX') {
            display = 'Display';
          } else {
            display = 'Invisible';
          }
        } else {
          display = 'Invisible';
        }
        break;
      }
      case 'RecordFound': {
        if (item.status === 'C' || item.status === 'W' || item.status === 'U') {
          if (item.recordFound === 'Y') {
            if (item.status !== 'W') {
              if (item.specialInstr === 'Y') {
                display = 'Disable';
              } else {
                display = 'Display';
              }
            } else if (item.status === 'W') {
              if (item.specialInstr === 'Y') {
                display = 'Disable';
              } else {
                display = 'Display';
              }
            }
          }
        } else {
          if (item.specialInstr === 'Y') {
            display = 'Disable';
          } else {
            display = 'Display';
          }
        }
        break;
      }
      default: {
        display = 'Display';
      }
    }
    return display;
  }
  getLinkColor(item: WorkOrder): string {
    if (item.specialInstr === 'Y') {
      return 'Gray';
    } else {
      return 'Blue';
    }
  }
  setCheckbox(item: WorkOrder, type: string): Boolean {
    let checked = false;
    switch (type) {
      case 'NoHits': {
        if (item.status === 'C' || item.status === 'W' || item.status === 'U') {
          if (item.recordFound === 'Y') {
            checked = true;
            item.woNoHitsDisable = true;
          }
        } else {
          if (item.specialInstr === 'Y') {
            item.woNoHitsDisable = true;
          }
          checked = false;
        }
        break;
      }
      case 'Manual': {
        if (item.ociIndicator === 'Y') {
          if (item.manualInd === 'Y') {
            checked = true;
          } else {
            checked = false;
          }
        }
        break;
      }
      case 'Pending': {
        if (item.status === 'P') {
          checked = true;
        } else {
          checked = false;
        }
        break;
      }
      case 'Deferred': {
        if (item.status === 'Q') {
          if (item.deferred === 'o') {
            checked = true;
          } else {
            checked = false;
          }
        }
        break;
      }
      case 'Admitted': {
        if (item.admittedCrimeNotFound === true) {
          checked = true;
          this.originalAdmitted.push(item.requestNbr);
        } else {
          checked = false;
        }
        break;
      }
      default: {
        checked = false;
      }
    }
    return checked;
  }
  setDisabled(item: WorkOrder, type: string): Boolean {
    let disable = false;
    switch (type) {
      case 'NoHits': {
        if (item.status === 'C' || item.status === 'W' || item.status === 'U') {
          if (item.recordFound === 'Y' || (item.specialInstr === 'Y')) {
            disable = true;
          } else if (item.recordFound === 'N' || (item.specialInstr === 'Y')) {
            disable = true;
          }
        } else {
          if (item.specialInstr === 'Y') {
            disable = true;
          }
        }
        break;
      }
      case 'Pending': {
        if (item.status === 'C' || item.status === 'W' || item.status === 'U') {
          disable = true;
        } else {
          disable = false;
        }
        break;
      }
      default: {
        disable = false;
      }
    }
    return disable;
  }
  pendingWorkOrder(objValue: string, requestNbr: string, caseNbr: string, refName: string, status: string) {
    this.getOriginalState(requestNbr);

    for (const item of this.wo) {
      if (item.requestNbr === +requestNbr) {
        this.woComplete.pendingComments = item.pendingComments;
        break;
      }
    }
    this.woComplete.requestNbr = requestNbr;
    this.woComplete.caseNbr = caseNbr;
    this.woComplete.refName = refName;
    this.woComplete.currentStatus = status;

    this.noHits = <HTMLInputElement>document.getElementById('cbNoHits' + requestNbr);
    this.pending = <HTMLInputElement>document.getElementById('cbPending' + requestNbr);

    if (objValue === 'Link') {
      if (!this.pending.checked) {
        this.woComplete.pendingComments = null;
        this.pendingWOHelper('Pending comment not checked.');
      } else if (this.woComplete.pendingComments === null || this.woComplete.pendingComments === '') {
        this.pendingWOHelper('There are no pending comments for this request.');
        this.pending.checked = false;
      } else {
        const holdComment = this.woComplete.pendingComments;
        if (this.woComplete.pendingComments === undefined) {
          this.woComplete.pendingComments = window.prompt('Please enter an explanation for placing this Work Order into a Pending Status.', '');
        } else {
          this.woComplete.pendingComments = window.prompt('Please enter an explanation for placing this Work Order into a Pending Status.', this.woComplete.pendingComments);
        }
        // canceled
        if (this.woComplete.pendingComments === null) {
          this.woComplete.pendingComments = holdComment;
          if (holdComment === '' || holdComment === undefined || holdComment === null) {
            this.pending.checked = false;
          } else {
            this.pending.checked = true;
          }
        }
        for (const item of this.wo) {
          if (item.requestNbr === +requestNbr) {
            if (this.pending.checked === true && (this.woComplete.pendingComments !== null || this.woComplete.pendingComments !== undefined)) {
              item.pendingComments = this.woComplete.pendingComments;
              break;
            } else if (this.pending.checked === false || this.woComplete.pendingComments === undefined) {
              item.pendingComments = null;
              break;
            }
          }
        }
        if (this.pending.checked === true) {
          this.woComplete.currentStatus = 'P';
          this.populateList(this.woComplete.requestNbr, this.woComplete.pendingComments, this.woComplete.currentStatus);
        }
      }
      return;
    }
    if (this.pending.checked === true) {
      if (this.woComplete.pendingComments === undefined || this.woComplete.pendingComments === null || this.woComplete.pendingComments === '') {
        this.woComplete.pendingComments = '';
      }

      this.woComplete.pendingComments = this.woComplete.pendingComments;
      this.woComplete.pendingComments = window.prompt('Please enter an explanation for placing this Work Order into a Pending Status.', this.woComplete.pendingComments);

      if (this.woComplete.pendingComments === undefined || this.woComplete.pendingComments === '' || this.woComplete.pendingComments === null) {
        this.pending.checked = false;
        if (this.noHits.checked === true) {
          this.noHits.checked = true;
        }
        this.pendingWOHelper('A comment must be entered when a Work Order is placed in Pending Status.');
      }
      if (this.woComplete.currentStatus === 'C') {
        this.woComplete.removeNoHit = `No longer marked as No Record - Reference Name: ${this.woComplete.refName} Work Order Nbr: ${this.woComplete.caseNbr}` + '\n\n';
        this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.removeNoHit, this.woComplete.removeNoHitsMsg, woc.removeNoHits);

        this.noHits.checked = false;
        this.woComplete.currentStatus = 'P';
        this.woComplete.pendingRequests = `Set To Pending - Reference Name: ${this.woComplete.refName}  Work Order Nbr: ${this.woComplete.caseNbr}` + '\n\n';
        this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.pendingRequests, this.woComplete.pendingRqstMsg, woc.pendingRequest);
      } else if (this.pending.checked === true) {
        this.woComplete.currentStatus = 'P';
        this.noHits.checked = false;
        this.woComplete.pendingRequests = `Set To Pending - Reference Name: ${this.woComplete.refName} Work Order Nbr: ${this.woComplete.caseNbr}` + '\n\n';
        this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.pendingRequests, this.woComplete.pendingRqstMsg, woc.pendingRequest);
      } else {
        this.woComplete.currentStatus = 'I';
        if (this.noHits.checked === true) {
          this.noHits.checked = true;
        } else {
          this.noHits.checked = false;
        }
      }
    } else {
      if (this.woComplete.currentStatus === 'P') {
        this.woComplete.removePending = `No longer marked as Pending - Reference Name: ${this.woComplete.refName} Work Order Nbr: ${this.woComplete.caseNbr}` + '\n\n';
        this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.removePending, this.woComplete.removePendingMsg, woc.removePending);
        this.pending.checked = false;
        this.woComplete.currentStatus = 'I';
      } else {
        this.woComplete.currentStatus = 'I';
        this.woComplete.removePending = '\n' + `No longer marked as Pending - Reference Name: ${this.woComplete.refName} Work Order Nbr: ${this.woComplete.caseNbr}` + '\n\n';
        this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.removePending, this.woComplete.removePendingMsg, woc.removePending);
      }
    }
    for (const item of this.wo) {
      if (item.requestNbr === +requestNbr) {
        if (this.woComplete.pendingComments !== '') {
          item.pendingComments = this.woComplete.pendingComments;
          break;
        }
      }
    }
    this.populateList(this.woComplete.requestNbr, this.woComplete.pendingComments, this.woComplete.currentStatus);
  }
  completeWorkOrder(requestNbr: string, caseNbr: string, refName: string) {
    this.woComplete.requestNbr = requestNbr;
    this.woComplete.caseNbr = caseNbr;
    this.woComplete.refName = refName;
    this.noHits = <HTMLInputElement>document.getElementById('cbNoHits' + requestNbr);
    this.pending = <HTMLInputElement>document.getElementById('cbPending' + requestNbr);

    if (this.noHits.checked === true) {
      if (this.pending.checked === true) {
        this.pending.checked = false;
      }
      this.noHitsConfirmation(`You have selected No Record Found. Select OK to confirm or Cancel to remove selection.`, requestNbr, true);
    } else {
      this.noHitsConfirmation(`You have removed the selection of No Record Found. Select OK to confirm or Cancel to keep No Record selected.`, requestNbr, false);
    }
  }
  populateList(requestNbr: string, comment: string, status: string) {
    if (!this.checkList(requestNbr)) {
      this.populateTaskList(requestNbr, comment, status, false);
    } else {
      this.submitTask = this.submitTask.filter(item => item.RequestNbr !== requestNbr);
      this.populateTaskList(requestNbr, comment, status, false);
    }
  }
  checkList(requestNbr: string): boolean {
    let exists = false;
    for (const item of this.submitTask) {
      if (item.RequestNbr === requestNbr) {
        exists = true;
        break;
      }
    }
    return exists;
  }
  openWindow(type: string, caseNbr: string, requestNbr: string, ) {
    switch (type) {
      case 'Edit': {
        this.confirmEditVerifications(requestNbr, caseNbr);
        break;
      }
      default: {
      }
    }
  }
  specialInstruction(requestNbr: string) {
    this.noHits = <HTMLInputElement>document.getElementById('cbNoHits' + requestNbr);
    for (const item of this.wo) {
      if (this.noHits.defaultValue === item.requestNbr.toString()) {
        item.woNoHitsDisable = false;
        item.woRecordDisplay = 'Display';
        item.linkColor = 'Blue';
        break;
      }
    }
    this.msgSvc.saveRequestNbrs(JSON.stringify(requestNbr));
    this.bwObjectService.openInNewWindowByRoute('specialInstruction', 'SIWin', '', 800, 520);
  }
  confirmEditVerifications(requestNbr, refNbr) {
    this.noHits = <HTMLInputElement>document.getElementById('cbNoHits' + requestNbr);
    this.pending = <HTMLInputElement>document.getElementById('cbPending' + requestNbr);
    this.woComplete.submit = 'true';
    const state = (this.noHits.checked === true || this.pending.checked === true) ? 1 : 0;
    let msg = '';
    if (this.noHits.checked === true) {
      msg = 'Selecting Ok will remove the selection of No Record.  Would you like to continue?';
      this.confirmRemovingNoRecordStatus(msg, refNbr, requestNbr, state);
    } else if (this.pending.checked === true) {
      msg = 'Would you like to remove the Pending Status on this request?  Select OK to remove it and Cancel to keep it.';
      this.confirmRemovingPendingStatus(msg, refNbr, requestNbr, state);
    } else if (this.submitTaskDialog.length > 0) {
      this.confirmWorkOrderStatus('OffenseEntry', true, 'R', requestNbr, state);
    } else {
      this.router.navigate(['offense', requestNbr]);
    }
  }
  confirmWorkOrderStatus(objFrom: string, valid: boolean, type: string, requestNbr: string, state: number) {
    this.woComplete.submit = 'true';
    this.sortTaskDialog();
    this.woComplete.alertMsg = undefined;

    for (const item of this.submitTaskDialog) {
      switch (item.type) {
        case 'PR':
          if (this.headerPR === 0) {
            if (this.woComplete.alertMsg === undefined) {
              this.woComplete.alertMsg = `${this.woComplete.msgLine} ${item.header} \n  ${item.comments} ${this.woComplete.breakLine}`;
            } else {
              this.woComplete.alertMsg = `${this.woComplete.alertMsg} ${this.woComplete.msgLine} ${item.header} \n ${item.comments} ${this.woComplete.breakLine}`;
            }
            this.headerPR = 1;
          } else {
            if (this.woComplete.alertMsg === undefined) {
              this.woComplete.alertMsg = `${item.comments} ${this.woComplete.breakLine}`;
            } else {
              this.woComplete.alertMsg = `${this.woComplete.alertMsg} ${item.comments} ${this.woComplete.breakLine}`;
            }
          }
          break;
        case 'RH': {
          if (this.headerRH === 0) {
            if (this.woComplete.alertMsg === undefined) {
              this.woComplete.alertMsg = `${this.woComplete.msgLine} ${item.header} \n ${item.comments} ${this.woComplete.breakLine}`;
            } else {
              this.woComplete.alertMsg = `${this.woComplete.alertMsg} ${this.woComplete.msgLine} ${item.header} \n  ${item.comments} ${this.woComplete.breakLine}`;
            }
            this.headerRH = 1;
          } else {
            if (this.woComplete.alertMsg === undefined) {
              this.woComplete.alertMsg = `${item.comments} ${this.woComplete.breakLine}`;
            } else {
              this.woComplete.alertMsg = `${this.woComplete.alertMsg} ${item.comments} ${this.woComplete.breakLine}`;
            }
          }
          break;
        }
        case 'RP': {
          if (this.headerRP === 0) {
            if (this.woComplete.alertMsg === undefined) {
              this.woComplete.alertMsg = `${this.woComplete.msgLine} ${item.header} \n ${item.comments} ${this.woComplete.breakLine}`;
            } else {
              this.woComplete.alertMsg = `${this.woComplete.alertMsg} ${this.woComplete.msgLine} ${item.header} \n ${item.comments} ${this.woComplete.breakLine}`;
            }
            this.headerRP = 1;
          } else {
            if (this.woComplete.alertMsg === undefined) {
              this.woComplete.alertMsg = `${item.comments} ${this.woComplete.breakLine}`;
            } else {
              this.woComplete.alertMsg = `${this.woComplete.alertMsg} ${item.comments} ${this.woComplete.breakLine}`;
            }
          }
          break;
        }
        case 'NH': {
          if (this.headerNH === 0) {
            if (this.woComplete.alertMsg === undefined) {
              this.woComplete.alertMsg = `${this.woComplete.msgLine} ${item.header} \n  ${item.comments} ${this.woComplete.breakLine}`;
            } else {
              this.woComplete.alertMsg = `${this.woComplete.alertMsg} ${this.woComplete.msgLine} ${item.header} \n ${item.comments} ${this.woComplete.breakLine}`;
            }
            this.headerNH = 1;
          } else {
            if (this.woComplete.alertMsg === undefined) {
              this.woComplete.alertMsg = `${item.comments} ${this.woComplete.breakLine}`;
            } else {
              this.woComplete.alertMsg = `${this.woComplete.alertMsg} ${item.comments} ${this.woComplete.breakLine}`;
            }
          }
          break;
        }
        default:
          break;
      }
    }

    if (type === 'S') {
      this.woComplete.alertMsgS = this.woComplete.alertMsg;
    } else if (type === 'R') {
      this.woComplete.alertMsgR = this.woComplete.alertMsg;
    }

    if (valid) {
      let msg = '';
      if (this.woComplete.alertMsg !== undefined) {
         this.woComplete.alertMsg = undefined;
        if (this.woComplete.alertMsgS !== undefined && type === 'S') {
          msg = `${this.woComplete.alertMsgS} ${this.woComplete.confirmationMsg}`;
        } else if (this.woComplete.alertMsgR !== undefined && type === 'R') {
          msg = `${this.woComplete.alertMsgR} ${this.woComplete.confirmationMsg}`;
        }
        this.confirmSubmit(msg, type, requestNbr);
      } else if (objFrom === 'Submit' && this.woComplete.alertMsgS === undefined && this.admittedCrimeCheckboxesChanged()) {
        this.getAllRequestsNotPreviouslyMarkedAdmittedCrimeNotFound();
        this.logComplianceLogs();
        this.submit();
        this.woComplete.submit = 'true';
        this.router.navigate(['navigation']);
      } else {
        if (objFrom === 'OffenseEntry') {
          if (this.woComplete.alertMsgR === '' || this.woComplete.alertMsgR === undefined || this.woComplete.alertMsgR === null) {
            this.woComplete.submit = 'noChange';
            this.router.navigate(['offense', requestNbr]);
          }
        }
        if (objFrom === 'Submit') {
          if (this.submitTask.length > 0) {
            this.getAllRequestsNotPreviouslyMarkedAdmittedCrimeNotFound();
            this.logComplianceLogs();
            this.submit();
            this.woComplete.submit = 'true';
            this.router.navigate(['navigation']);
          } else if (this.woComplete.alertMsgS === undefined && !this.admittedCrimeCheckboxesChanged()) {
            this.noChangeHelper();
            this.woComplete.submit = 'noChange';
          }
        }
      }
    } else {
      if (objFrom === 'OffenseEntry' && state === 0) {
        this.router.navigate(['offense', requestNbr]);
      } else {
        this.woComplete.submit = '';
        if (requestNbr !== '') {
          for (const item of this.wo) {
            if (requestNbr === item.requestNbr.toString()) {
              item.woNoHitsDisable = false;
              item.woRecordDisplay = 'Display';
              break;
            }
          }
        }
      }
    }
  }

  filterWorkOrderList() {
    if (this.model.selectedValue !== 'ns') {
    if (localStorage.getItem('jurisdictionId') !== '0' && localStorage.getItem('jurisdictionId') !== null ) {
         this.model.jurisdictionId = JSON.parse(localStorage.getItem('jurisdictionId'));
         localStorage.removeItem('jurisdictionId');
       } else {
        this.model.jurisdictionId = this.model.selectedValue;
      }
      this.getResearcherTaskData();
    }
  }
  submitTaskListDisabled(): boolean {
    return (this.model.isSubmitDisabled) ? true : false;
  }
  submitTaskList() {
    this.model.isSubmitDisabled = true;
    this.confirmWorkOrderStatus('Submit', true, 'S', '', 1);
    if (this.woComplete.submit === 'noChange') {
      this.model.isSubmitDisabled = false;
      return;
    }
  }
  submit() {
    this.researcherService.submitTaskListData(this.submitTask)
      .subscribe(
        (data) => {
          if (data === 200) {
            this.woComplete = new WorkOrderComplete;
          } else {
            PopupHelper.userHelper('Unable to submit updates', 'error');
          }
          this.model.isSubmitDisabled = false;
        });
  }
  selectAll() {
    this.wo.forEach((item) => {
      item.checked = true;
    });
  }
  removeAllSelection() {
    this.wo.forEach((item) => {
      item.checked = false;
    });
  }
  getAllAdmitted() {
    this.admittedAll.length = 0;
    this.wo.forEach((item) => {
      if (item.woAdmittedChecked) {
        this.admittedAll.push(item.requestNbr);
      }
    });
  }
  getAdmittedChecked(requestNbr: string) {
    this.anf = <HTMLInputElement>document.getElementById('cbAdmitted' + requestNbr);
    if (!this.anf.checked) {
      this.wo.forEach((item) => {
        if (item.requestNbr === +requestNbr && item.woAdmittedChecked === true) {
          item.woAdmittedChecked = false;

          this.filterList(requestNbr);

          this.submitTask = this.submitTask.filter(x => x.RequestNbr !== requestNbr);
          this.populateTaskList(requestNbr, '', 'ANF', false);
        }
      });
    } else if (this.anf.checked) {
      this.wo.forEach((item) => {
        if (item.requestNbr === +requestNbr && item.woAdmittedChecked === false) {
          item.woAdmittedChecked = true;
          this.filterList(requestNbr);
           this.populateTaskList(requestNbr, '', 'ANF', true);
        }
      });
    }
  }
  admittedCrimeCheckboxesChanged(): boolean {
    let inArray = false;
    this.getAllAdmitted();

    for (const allRqsts of this.admittedAll) { // all checked items
      if (this.checkedChange(this.originalAdmitted, allRqsts)) {
        inArray = false;
      } else {
        inArray = true;
        break;
      }
    }
    return inArray;
  }
  getAllRequestsNotPreviouslyMarkedAdmittedCrimeNotFound() {
    this.getAllAdmitted();
    for (const allRqsts of this.admittedAll) { // all checked items
      if (!this.checkedChange(this.originalAdmitted, allRqsts)) {
        this.filterList(allRqsts);
        this.populateTaskList(allRqsts, '', 'ANF', true);
      }
    }
  }
  async logComplianceLogs() {
    this.getAllAdmitted();
    for (const allRqsts of this.admittedAll) { // all checked items
      if (!this.checkedChange(this.originalAdmitted, allRqsts)) {

        try {
          await this.complianceAuditLogService.addComplianceAuditLogs([
            new ComplianceAuditLog(allRqsts, 'ADMTTD_CRM_NOT_FND', 'ResearcherTaskList', null, null)
          ]);
        } catch (e) {
        }
      }
    }
  }
  checkedChange(arr: any, test: number) {
    return arr.some(function (arrVal) {
      return test === arrVal;
    });
  }
  populateTaskList(requestNbr: string, comment: string, status: string, checked: boolean) { // dialogComment: string) {
    this.submitList = {
      RequestNbr: requestNbr,
      PendingComments: comment,
      Type: status,
      AdmittedCrimeNotFound: checked,
    };
    this.submitTask.push(this.submitList);
  }
  goToNavigation() {
    this.router.navigate(['navigation']);
  }
  gotoTop() {
    window.scrollTo(0, 0);
  }
  displayReport(rptType: string) {
    for (const item of this.wo) {
      if (item.checked === true) {
        this.requestNbrs.push({ requestNbr: item.requestNbr });
      }
    }
    if (this.requestNbrs.length <= 0) {
      if (rptType === 'Received') {
        this.receivedDialog();
      } else if (rptType === 'Report') {
        this.reportDialog();
      }
    } else {
      if (rptType === 'Received') {
        this.researcherService.markRequestReceived(this.requestNbrs)
          .subscribe(() => {
            if (this.researcherService.successful) {
              this.goToNavigation();
            }
          });
      } else if (rptType === 'Report') {
        this.msgSvc.saveRequestNbrs(JSON.stringify(this.requestNbrs));
        this.bwObjectService.openInNewWindowByRoute('workOrderReport', 'WOWin', '', 920, 430);
        this.goToNavigation();
      }
    }
  }
  createDateTime() {
    const today = new Date();
    const year = this.takeYear(today);
    const month = this.leadingZero(today.getMonth() + 1);
    const day = this.leadingZero(today.getDate());
    const minutes = this.leadingZero(today.getMinutes());
    const seconds = this.leadingZero(today.getSeconds());
    let hours = today.getHours();
    let ampm = 'am';
    if (hours === 0) {
      hours = 12;
    } else if (hours > 11) {
      ampm = 'pm';
    } else if (hours > 12) {
      hours -= 12;
    }
    hours = this.leadingZero(hours);
    return (month + '/' + day + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + ampm);
  }
  takeYear(dte) {
    return ((dte.getYear() % 100) < 38) ? 2000 : 1900;
  }
  leadingZero(nbr) {
    if (nbr < 10) {
      nbr = '0' + nbr;
    }
    return nbr;
  }
  showComment(requestNbr: string, status: string) {
    this.msgSvc.saveRequestNbrs(JSON.stringify(requestNbr));
    this.msgSvc.saveStatus(JSON.stringify(status));
    this.bwObjectService.openInNewWindowByRoute('comment', 'SIWin', '', 1005, 375);
  }
  searchCapture(userID: string, requestNbr: string) {
    this.bwObjectService.searchCaptureOpen(`http://dev2paperlesscrim.geninfo.com/IncomingUser.aspx?su=${userID}|${requestNbr}`);
  }
  watsonShowGuideline(route: string) {
    const address = route.substr(8);
    this.bwObjectService.watsonShowGuideline(`http://dev2watson.geninfo.com/${address}`);
  }
  showLink(): Boolean {
    if (this.model.viewAsLink === true) {
      return true;
    } else {
      return false;
    }
  }
  help() {
    this.bwObjectService.openWindowInNewWindowByRoute(`researcherHelp`, '', 800, 900);
  }
  // ALERTS
  async receivedDialog() {
    const alertResult = await PopupHelper.userHelper('You have not selected any items to mark as received.', 'crim');
    if (alertResult === AlertResult.Ok) {
      return;
    }
  }
  async reportDialog() {
    const alertResult = await PopupHelper.userHelper('You have not selected any items to print.', 'crim');
    if (alertResult === AlertResult.Ok) {
      return;
    }
  }
  async exitDialog() {
    const confirmResult = await PopupHelper.exitSystemHelper();

    if (confirmResult === ConfirmResult.Ok) {
      this.router.navigate(['exit']);
    }
  }

  async confirmRemovingNoRecordStatus(message: string, refNbr: string, requestNbr: string, state: number) {
    let oHits = false;
    const confirmResult = await PopupHelper.confirmSubmitHelper(message);
    if (confirmResult === ConfirmResult.Ok) {
      this.woComplete.removeNoHit = `\n No longer marked as No Record - Work Order Nbr: ${refNbr} Request Nbr: ${requestNbr}`;
      this.populateSubmitComments(requestNbr, refNbr, this.woComplete.removeNoHit, this.woComplete.removeNoHitsMsg, woc.removeNoHits);
      this.noHits.checked = false;
      this.woComplete.persist = 'I';
      this.woComplete.closeDt = '';
      this.woComplete.newStatus = 'I';
      this.populateList(requestNbr, '', this.woComplete.newStatus);
    } else {
      this.noHits.checked = true;
      oHits = this.noHits.checked;
      this.populateList(requestNbr, '', this.woComplete.newStatus);
    }
    this.woComplete.submit = '';
    this.confirmWorkOrderStatus('OffenseEntry', (oHits || this.pending.checked) ? true : false, 'R', this.noHits.defaultValue, state);
  }
  async confirmRemovingPendingStatus(message: string, refNbr: string, requestNbr: string, state: number) {
    let oPending = false;
    const confirmResult = await PopupHelper.confirmSubmitHelper(message);
    if (confirmResult === ConfirmResult.Ok) {
      this.woComplete.removePending = `\n No longer marked as Pending - Work Order Nbr: ${refNbr} Request Nbr: ${requestNbr}`;
      this.populateSubmitComments(requestNbr, refNbr, this.woComplete.removePending, this.woComplete.removePendingMsg, woc.removePending);
      oPending = this.pending.checked;
      this.pending.checked = false;
      this.woComplete.persist = 'I';
      this.woComplete.closeDt = '';
      this.woComplete.newStatus = 'I';
      this.populateList(requestNbr, '', this.woComplete.newStatus);
    } else {
      this.pending.checked = true;
      oPending = this.pending.checked;
    }
    this.woComplete.submit = '';
    this.confirmWorkOrderStatus('OffenseEntry', (this.noHits.checked || oPending) ? true : false, 'R', this.noHits.defaultValue, state);
  }
  async confirmSubmit(message: string, type: string, requestNbr: string) {
    const confirmResult = await PopupHelper.confirmSubmitHelper(message);

    if (confirmResult === ConfirmResult.Ok) {
      if (type === 'S') {
        this.getAllRequestsNotPreviouslyMarkedAdmittedCrimeNotFound();
        this.logComplianceLogs();
        this.submit();
        this.woComplete.submit = 'true';
        this.router.navigate(['navigation']);
      } else if (type === 'R') {
        if (this.woComplete.submit === 'noChange') {
          this.woComplete.work = 'Retrieve';
          this.woComplete.detailWork = 'Add';
          this.router.navigate(['offense', requestNbr]);
        }
        if (this.woComplete.submit === 'true') {
          if (this.submitTask.length !== 0) {
            this.submit();
          } else {
            this.populateList(requestNbr, '', this.woComplete.newStatus);
            this.submit();
          }
          this.woComplete.work = 'PersistFirst';
          this.router.navigate(['offense', requestNbr]);
        }
      }
    } else {
      if (type === 'S') {
        this.model.isSubmitDisabled = false;
        this.woComplete.submit = 'false';
        this.woComplete.alertMsg = '';
        PopupHelper.userHelper('You have chosen to cancel the submit, your changes have not been saved.',
          'crim');
      } else if (type === 'R') {
        this.woComplete.submit = 'false';
        PopupHelper.userHelper('You have selected not to continue to the offense page.', 'crim');
      }
      this.headerNH = 0;
      this.headerPR = 0;
      this.headerRP = 0;
      this.headerRH = 0;
    }
  }
  getOriginalState(requestNbr: any) {
    for (const item of this.stateData) {
      if (requestNbr === item.requestNbr) {
        this.originalStatus = item.status;
        return;
      }
    }
  }
  support() {
    PopupHelper.support();
  }
  about() {
    PopupHelper.systemVersion();
  }
  async crimAlert(message: string) {
    const alertResult = await PopupHelper.userHelper(message, 'prompt');
    if (alertResult === AlertResult.Ok) {

    }
  }
  sortWorkOrderList() {
    this.msgSvc.selectedValue(JSON.stringify(this.model.selectedValue));
    this.msgSvc.selectedJurisdiction(JSON.stringify(this.model.jurisdictionId));
    this.router.navigate(['sortTaskList', this.model.requestType]);
  }
  removeSortingArray() {
    localStorage.removeItem('sortType');
  }
  setDefaultOrder() {
    this.config = ['+jurisdiction'];
    this.config.push(`-dis_RequestDt_sort`);
    this.config.push(`+refName`);
    this.config.push(`+caseNbr`);
    this.msgSvc.saveSortOrder(JSON.stringify(this.config));
  }
  async pendingWOHelper(alertMsg: string) {
    const message = alertMsg;
    const alertResult = await PopupHelper.pendingWOHelper(message);
    if (alertResult === AlertResult.Ok) {
      return;
    }
  }
  async noChangeHelper() {
    const alertResult = await PopupHelper.noChangesToTaskList();
    if (alertResult === AlertResult.Ok) {
      return;
    }
  }
  async noHitsConfirmation(alertMsg: string, requestNbr: string, checked: boolean) {
    const message = alertMsg;
    const confirmResult = await PopupHelper.noHitsConfirmation(message);
    if (confirmResult === ConfirmResult.Ok) {
      if (checked) {
        if (this.pending.checked === true) {
          this.woComplete.removePending = `No longer marked as Pending -   Reference Name: ${this.woComplete.refName}  Work Order Nbr: ${this.woComplete.caseNbr} \n\n `;
          this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.removePending, this.woComplete.removePendingMsg, woc.removePending);
        }
        this.woComplete.noHitRequests = `Marked Complete - Reference Name: ${this.woComplete.refName} Work Order Nbr: ${this.woComplete.caseNbr} \n\n`;
        this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.noHitRequests, this.woComplete.noHitsMsg, woc.noHits);

        this.woComplete.currentDte = this.createDateTime();
        this.woComplete.newStatus = 'C';
      } else {
        this.woComplete.removeNoHit = `No longer marked as No Record -  Reference Name: ${this.woComplete.refName} Work Order Nbr: ${this.woComplete.caseNbr} \n\n`;
        this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.removeNoHit, this.woComplete.removeNoHitsMsg, woc.removeNoHits);

        if (this.woComplete.newStatus === 'C') {
          this.woComplete.newStatus = 'I';
        }
      }
      this.populateList(this.woComplete.requestNbr, '', this.woComplete.newStatus);
    } else {
      if (checked) {
        this.noHits.checked = false;
      } else {
        this.noHits.checked = true;
      }
    }
  }
  populateSubmitComments(requestNbr: string, caseNbr: string, comment: string, header: string, type: string) {
    this.submitTaskDialog = this.submitTaskDialog.filter(item => item.requestNbr !== requestNbr);

    const records = new SubmitTaskDialog;
    records.requestNbr = requestNbr;
    records.caseNbr = caseNbr;
    records.comments = comment;
    records.header = header;
    records.type = type;
    this.submitTaskDialog.push(records);
  }
  sortTaskDialog() {
    this.submitTaskDialog.sort((a, b) => {
      if (a.type < b.type) {
        return -1;
      } else if (a.type > b.type) {
        return 1;
      } else {
        return 0;
      }
    });
  }
  filterList(requestNbr: string) {
    this.filter = this.submitTask.filter(x => x.RequestNbr === requestNbr);
    this.filter = this.filter.filter(x => x.Type !== 'ANF');
    this.submitTask = this.submitTask.filter(x => x.RequestNbr !== requestNbr);

    for (const ftr of this.filter) {
      this.populateTaskList(ftr.RequestNbr, ftr.PendingComments, ftr.Type, ftr.AdmittedCrimeNotFound);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/researcherTaskList/researcherTaskList.component.ts